
































































import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import Tags from '../../../../Tags/Tags.vue'
import { Placeholder } from '../../Toolbar/types'

@Component({
  components: {
    Tags
  },
  name: "PlaceholderValueItem"
})
export default class PlaceholderValueItem extends Vue {
  @Prop({ required: true, type: Object }) placeholderItem!:Placeholder

  @Prop({ type: Boolean, default: false }) stack!: boolean

  @Emit('select')
  placeholderItemSelect(value: string): string {
    return value
  }

  isActive = false
}
